// Contract text writes dates the way people do ("4 May 2022", "04/05/2022"),
// while extracted values are stored as ISO dates ("2022-05-04"). These are the
// day-first forms used in UK contracts; month-first forms are left out because
// they would match a different day.

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const ordinal = (day: number) => {
  if (day >= 11 && day <= 13) return `${day}th`
  return `${day}${{ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th'}`
}

export const isoDateSearchVariants = (value: string): string[] => {
  const match = /^\s*(\d{4})-(\d{2})-(\d{2})\s*$/.exec(String(value || ''))
  if (!match) return []
  const [, year, monthText, dayText] = match
  const month = Number(monthText)
  const day = Number(dayText)
  if (month < 1 || month > 12 || day < 1 || day > 31) return []
  const monthName = MONTHS[month - 1]
  const shortMonth = monthName.slice(0, 3)
  return Array.from(
    new Set([
      `${day} ${monthName} ${year}`,
      `${ordinal(day)} ${monthName} ${year}`,
      `${day} ${shortMonth} ${year}`,
      `${day} ${shortMonth}. ${year}`,
      `${dayText}/${monthText}/${year}`,
      `${day}/${month}/${year}`,
      `${dayText}.${monthText}.${year}`,
    ])
  ).map((variant) => variant.toLowerCase())
}
